import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import DeleteIcon from "@mui/icons-material/Delete";
import { Add, Height } from "@mui/icons-material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import "ag-grid-community/styles/ag-grid.css"; // AG Grid styles
import "ag-grid-community/styles/ag-theme-alpine.css";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import { tableShadow, globalStyles } from "components/Styles/globalStyles";
import {
  TableContainer,
  Paper,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Grid,
  Box,
  Button,
  Radio,
  TextField,
  Typography,
  Tooltip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress,
} from "@mui/material";
import {
  ViewButton,
  DeleteButton,
  StyledTypography,
  StyledButton,
  StyledButtonC,
  StyledAlert,
  StyledSnackbar,
  inputStyle,
  StyledTableContainer,
  StyledAgGridContainer,
} from "components/StyledComponents/styledComponents.js";
import { dsaMasterStyles } from "components/Styles/dsaMasterStyles";
//import DSABankAccountsDialog from "./bankAccountsPage";
import { IconButton } from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; // Bank-related icon
import URLs from "constants/urls";
import Cookie from "js-cookie";
import ResponsiveTabs from "components/StyledComponents/styledComponents";

export default function DsaMaster() {
  const [activeTab, setActiveTab] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedDSACode, setSelectedDSACode] = useState("");
  const [selectedDSAName, setSelectedDSAName] = useState("");
  const [selectedDSAStatus, setSelectedDSAStatus] = useState("");
  const [accountId, setAccountId] = useState(0);
  const [selectedStreet, setSelectedStreet] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState("");
  const [selectedEmailID, setSelectedEmailID] = useState("");
  const [selectedContactPerson, setSelectedContactPerson] = useState("");
  const [selectedDSAType, setSelectedDSAType] = useState("");
  const [isDsaHasGst, setIsDsaHasGst] = useState("");
  const [gstNo, setGstNo] = useState(true);
  const [panNumber, setPanNumber] = useState("");
  const [tableData, setTableData] = useState([]);
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [dsaIdNum, setDsaIdNum] = useState("");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteDsaById, setDeleteDsaById] = useState(0);
  const [loading, setLoading] = useState(false);
  const [deleteDsaName, setDeleteDsaName] = useState("");
  const [openBankDailog, setOpenBankDailog] = useState(false);
  const MInput = inputStyle();
  const jwt_token = Cookie.get("jwt_token");
  const tabs = [{ label: "DSA List" }, { label: "Create DSA" }];
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    fetchDsaMasterData();
  }, []);
  const fetchDsaMasterData = async () => {
    const url = URLs.dsaMasterGetUrl;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      const { data } = await response.json();
      const sortedDsaData = data.sort((a, b) => a.dsaName.localeCompare(b.dsaName));
      setTableData(sortedDsaData);
    } catch (error) {
      setAlert("Failed to fetch data", "error");
    }
    setLoading(false);
  };
  const postDsaMasterApiCall = async (newDsa) => {
    const url = URLs.newDsaPostUrl;
    newDsa = {
      dsaId: 0,
      dsaType: selectedDSAType,
      dsaCode: selectedDSAName,
      panNumber: panNumber,
      dsaName: selectedDSAName,
      dsaStatus: selectedDSAStatus,
      contactpersonName: selectedContactPerson,
      address: {
        street: selectedStreet,
        city: selectedCity,
        state: selectedState,
      },
      phoneNumber: selectedPhoneNumber,
      emailId: selectedEmailID,
      gstnumber: gstNo,
      gststatus: isDsaHasGst.charAt(0),
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
      body: JSON.stringify(newDsa),
    };

    setLoading(true); // Start loading

    try {
      const response = await fetch(url, options);
      const responseData = await response.json();

      if (response.ok) {
        fetchDsaMasterData(); // Refresh the DSA master list
        setAlert(responseData.message || "Posted successfully", "success"); // Show server message
        setIsEditMode(false); // Exit edit mode
        resetFormFields(); // Reset form fields if available
        setActiveTab(0);
      } else {
        const errorMessage = responseData.message || "Failed to post DSA data";
        throw new Error(errorMessage); // Throw error with message from server
      }
    } catch (error) {
      setAlert("Failed to Post: " + error.message, "error"); // Show error message
    }
    setLoading(false);
  };
  const deleteDsaMasterApiCall = async (id) => {
    const url = `${URLs.dsaMasterGetUrl}/${id}`;
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      if (response.ok) {
        fetchDsaMasterData();
        setAlert("Deleted Successfully", "success");
        setIsEditMode(false);
        resetFormFields();
      } else {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
    } catch (error) {
      setAlert("Failed to Delete: " + error.message, "error");
    }
    setLoading(false);
  };
  const putDsaMasterApiCall = async () => {
    const url = `${URLs.dsaMasterGetUrl}/${dsaIdNum}`;
    const updatedDsa = {
      dsaId: dsaIdNum,
      accountId,
      dsaType: selectedDSAType,
      dsaCode: selectedDSACode,
      panNumber: panNumber,
      dsaName: selectedDSAName,
      dsaStatus: selectedDSAStatus,
      contactpersonName: selectedContactPerson,
      address: {
        street: selectedStreet,
        city: selectedCity,
        state: selectedState,
      },
      phoneNumber: selectedPhoneNumber,
      emailId: selectedEmailID,
      gstnumber: gstNo,
      gststatus: isDsaHasGst.charAt(0),
    };
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
      body: JSON.stringify(updatedDsa),
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      if (response.ok) {
        fetchDsaMasterData();
        setAlert("Updated Successfully", "success");
        setIsEditMode(false);
        resetFormFields();
        setActiveTab(0);
      } else {
        const errData = await response.json(); // Parse response body
        const errorMessage = errData?.message || "Failed to Update";
        throw new Error(errorMessage);
      }
    } catch (error) {
      setAlert("Failed to Update: " + error.message, "error");
    }
    setLoading(false);
  };
  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const formatInputValue = (value) => {
    return value.replace(/^\s+|\s+$/g, " ").replace(/\s+/g, " ");
  };
  const handleViewClick = (rowData) => {
    setActiveTab(1);
    setSelectedDSACode(rowData.dsaCode || "");
    setSelectedDSAName(rowData.dsaName || "");
    setSelectedDSAStatus(rowData.dsaStatus || "");
    setSelectedStreet(rowData.address.street || "");
    setSelectedCity(rowData.address.city || "");
    setSelectedState(rowData.address.state || "");
    setSelectedPhoneNumber(rowData.phoneNumber || "");
    setSelectedEmailID(rowData.emailId || "");
    setSelectedContactPerson(rowData.contactpersonName || "");
    setSelectedDSAType(rowData.dsaType || "");
    setDsaIdNum(rowData.dsaId);
    setAccountId(rowData.accountId);
    setGstNo(rowData.gstnumber || "");
    setIsDsaHasGst(rowData.gststatus || "");
    setPanNumber(rowData.panNumber || "");
    setIsEditMode(true);
  };

  const resetFormFields = () => {
    setSelectedDSACode("");
    setSelectedDSAName("");
    setSelectedDSAStatus("");
    setSelectedStreet("");
    setSelectedCity("");
    setSelectedState("");
    setSelectedPhoneNumber("");
    setSelectedEmailID("");
    setSelectedContactPerson("");
    setSelectedDSAType("");
    setIsDsaHasGst("");
    setGstNo("");
    setPanNumber("");
    setIsEditMode(false);
  };

  const handleSave = (event) => {
    event.preventDefault();
    if (!selectedDSAType || !selectedDSAStatus) {
      setAlert("DSA Type and DSA Status are required", "error");
      return;
    }
    if (!isEditMode) {
      postDsaMasterApiCall();
    } else {
      putDsaMasterApiCall();
    }
  };

  const ActionCellRenderer = (props) => {
    const rowIndex = props.node.rowIndex;
    const rowData = props.api.getDisplayedRowAtIndex(rowIndex).data;
    const handleEdit = () => {
      handleViewClick(rowData);
    };

    const handleDelete = () => {
      setOpenDialog(true);
      setDeleteDsaById(rowData.dsaId);
      setDeleteDsaName(rowData.dsaName);
    };

    return (
      <div>
        <ViewButton onClick={handleEdit}>
          <EditIcon />
        </ViewButton>
        <DeleteButton onClick={handleDelete}>
          <DeleteIcon />
        </DeleteButton>
      </div>
    );
  };
  const columnDefs = [
    {
      headerName: "DSA Name",
      field: "dsaName",
      editable: true,
      sortable: true,
      filter: true,
      flex: 2,
    },
    { headerName: "DSA Code", field: "dsaCode", sortable: true, filter: true, flex: 1 },
    { headerName: "DSA Type", field: "dsaType", sortable: true, filter: true, flex: 1 },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: ActionCellRenderer,
      width: 100,
    },
  ];
  const resetFormState = () => {
    resetFormFields();
    setIsEditMode(false);
  };
  function handleConfirmDelete() {
    deleteDsaMasterApiCall(deleteDsaById); // Only delete if entryId exists
    setTimeout(() => {
      setOpenDialog(false);
    }, 1000);
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "12px",
        overflow: "auto",
        flexGrow: 1,
        boxShadow: "none",
        border: "none",
        height: "100%",
        pt: 2,
        backgroundColor: "transparent",
      }}
    >
      <Dialog open={openDialog}>
        <DialogContent sx={subDialogContentStyle}>
          <DialogContentText sx={dialogContentTextStyle}>
            {`Are you sure you want to delete ${deleteDsaName}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={dsaMasterStyles.dialogActions}>
          <StyledButton onClick={handleConfirmDelete}>Yes</StyledButton>
          <StyledButton onClick={() => setOpenDialog(false)} variant="outlined">
            No
          </StyledButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
      >
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <ResponsiveTabs
        tabs={tabs}
        activeTab={activeTab}
        onChange={handleChange}
        labelColor="secondary"
        bgColor="#e0f7fa"
      />
      {/* <DSABankAccountsDialog
          open={openBankDailog}
          onClose={() => setOpenBankDailog(false)}
          dsaId={dsaIdNum}
          setAlert={setAlert}
        /> */}
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          mt: 1,
          pt: 1,
          backgroundColor: "transparent",
          boxShadow: "none",
          border: "none",
        }}
      >
        {activeTab === 0 && (
          <Box
            sx={{
              overflowX: "auto",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
            }}
          >
            <StyledAgGridContainer
              component={Paper}
              className={`ag-theme-alpine`}
              sx={{
                flexGrow: 1,
                height: "100%",
                backgroundColor: "transparent",
                boxShadow: "none",
                border: "none",
              }}
            >
              <AgGridReact
                rowData={tableData} // Pass the table data
                columnDefs={columnDefs} // Define columns
                pagination={true} // Enable pagination
                paginationPageSize={11}
              />
            </StyledAgGridContainer>
          </Box>
        )}
        {activeTab === 1 && (
          <StyledTableContainer
            container
            spacing={1}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#ffffff",
              height: "100%",
              flexGrow: 1,
              mt: 0,
              borderRadius: "15px",
            }}
          >
            <Grid
              container
              spacing={1}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={12} md={12} lg={10}>
                <TableContainer component={Paper} sx={{ position: "relative", boxShadow: "none" }}>
                  <div
                    className={{ ...dsaMasterStyles.divStyle, boxShadow: "none" }}
                    style={{ position: "relative" }}
                  >
                    <StyledTypography>
                      {!isEditMode ? "Entry Form" : "Edit Entry Details"}
                    </StyledTypography>
                    {isEditMode && (
                      <Tooltip title="Reset">
                        <StyledButtonC onClick={resetFormState}>
                          <RestartAltIcon />
                        </StyledButtonC>
                      </Tooltip>
                    )}
                  </div>
                  <Grid sx={{ ...dsaMasterStyles.root }}>
                    <form
                      onSubmit={handleSave}
                      className={dsaMasterStyles.formStyle}
                      autoComplete="off"
                    >
                      <Grid pt={1} container spacing={2}>
                        <Grid
                          container
                          direction="row"
                          spacing={2}
                          wrap="nowrap" // Ensures everything stays in one row
                          justifyContent="space-between"
                          alignItems="center"
                          sx={{ ml: 3, overflow: "wrap", minWidth: 0, flexWrap: "wrap" }} // Prevents wrapping
                        >
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={isEditMode ? 3.5 : 4}
                            container
                            alignItems="center"
                          >
                            <label style={{ color: MInput.a, ...dsaMasterStyles.radioClass }}>
                              DSA Status:
                            </label>
                            <FormControl fullWidth>
                              <RadioGroup
                                row
                                name="DSAStatus"
                                value={selectedDSAStatus}
                                onChange={(e) => setSelectedDSAStatus(e.target.value)}
                                sx={{ ...MInput.b }}
                              >
                                <FormControlLabel
                                  value="S"
                                  control={
                                    <Radio
                                      defaultChecked
                                      sx={{ color: MInput.a, ...dsaMasterStyles.radioStyle }}
                                    />
                                  }
                                  label="Self"
                                />
                                <FormControlLabel
                                  value="O"
                                  control={<Radio defaultChecked sx={dsaMasterStyles.radioStyle} />}
                                  label="Others"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                          {/* <Grid
                              item
                              xs={12}
                              sm={6}
                              md={isEditMode ? 3.5 : 4}
                              container
                              alignItems="center"
                            >
                              <label style={{ color: MInput.a, ...dsaMasterStyles.radioClass }}>
                                DSA Type:
                              </label>
                              <FormControl fullWidth>
                                <RadioGroup
                                  row
                                  name="DSAType"
                                  value={selectedDSAType}
                                  onChange={(e) => setSelectedDSAType(e.target.value)}
                                >
                                  <FormControlLabel
                                    value="DMA"
                                    control={
                                      <Radio defaultChecked sx={dsaMasterStyles.radioStyle} />
                                    }
                                    label="DMA"
                                  />
                                  <FormControlLabel
                                    value="DSA"
                                    control={
                                      <Radio defaultChecked sx={dsaMasterStyles.radioStyle} />
                                    }
                                    label="DSA"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid> */}
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={isEditMode ? 3.5 : 4}
                            container
                            alignItems="center"
                          >
                            <label style={{ color: MInput.a, ...dsaMasterStyles.radioClass }}>
                              DSA Type:
                            </label>
                            <FormControl fullWidth>
                              <RadioGroup
                                row
                                name="DSAType"
                                value={selectedDSAType}
                                onChange={(e) => setSelectedDSAType(e.target.value)}
                              >
                                {/* Direct Marketing Agent */}
                                <Tooltip title="Direct Marketing Agent" placement="top" arrow>
                                  <FormControlLabel
                                    value="DMA"
                                    control={<Radio sx={dsaMasterStyles.radioStyle} />}
                                    label="DMA"
                                  />
                                </Tooltip>
                                {/* Direct Selling Agent */}
                                <Tooltip title="Direct Selling Agent" placement="top" arrow>
                                  <FormControlLabel
                                    value="DSA"
                                    control={<Radio sx={dsaMasterStyles.radioStyle} />}
                                    label="DSA"
                                  />
                                </Tooltip>
                                {/* Connector */}
                                <Tooltip title="Connector" placement="top" arrow>
                                  <FormControlLabel
                                    value="CNT"
                                    control={<Radio sx={dsaMasterStyles.radioStyle} />}
                                    label="CNT"
                                  />
                                </Tooltip>
                                {/* Sub-Branch */}
                                <Tooltip title="Sub-Branch (Regional Office)" placement="top" arrow>
                                  <FormControlLabel
                                    value="SBR"
                                    control={<Radio sx={dsaMasterStyles.radioStyle} />}
                                    label="SBR"
                                  />
                                </Tooltip>
                                {/* <Tooltip title="Insurance Agent" placement="top" arrow>
                                    <FormControlLabel
                                      value="AGT"
                                      control={<Radio sx={dsaMasterStyles.radioStyle} />}
                                      label="AGT"
                                    />
                                  </Tooltip> */}
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={isEditMode ? 3.5 : 4}
                            container
                            alignItems="center"
                          >
                            <label style={{ color: MInput.a, ...dsaMasterStyles.radioClass }}>
                              Is GST Applicable:
                            </label>
                            <FormControl fullWidth>
                              <RadioGroup
                                row
                                name="DSAStatus"
                                value={isDsaHasGst}
                                onChange={(e) => setIsDsaHasGst(e.target.value)}
                                sx={{ ...MInput.b }}
                              >
                                <FormControlLabel
                                  value="Y"
                                  control={
                                    <Radio
                                      defaultChecked
                                      sx={{ color: MInput.a, ...dsaMasterStyles.radioStyle }}
                                    />
                                  }
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="N"
                                  control={<Radio defaultChecked sx={dsaMasterStyles.radioStyle} />}
                                  label="No"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                          {isEditMode && (
                            <Grid item xs={12} sm={6} md={1.5} container alignItems="center">
                              <Tooltip title="Add Bank Account">
                                <IconButton
                                  color="primary"
                                  onClick={() => setOpenBankDailog(true)}
                                  sx={{
                                    backgroundColor: "#f5f5f5",
                                    "&:hover": { backgroundColor: "#e0e0e0" },
                                    boxShadow: 2,
                                    borderRadius: "8px",
                                    padding: "6px",
                                    fontSize: "small",
                                    transition: "transform 0.3s ease, background-color 0.3s ease",
                                    "&:hover": {
                                      transform: "scale(1.1)",
                                    },
                                    "&:active": {
                                      transform: "scale(0.95)", // Slightly reduce scale on click
                                    },
                                    "&:focus": {
                                      outline: "none", // Remove focus outline
                                    },
                                  }}
                                >
                                  <AccountBalanceIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          )}
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <TextField
                              label="DSA Name"
                              required
                              value={selectedDSAName}
                              onChange={(e) => setSelectedDSAName(formatInputValue(e.target.value))}
                              fullWidth
                              variant="outlined"
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>
                        {isDsaHasGst === "Y" && (
                          <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                              <TextField
                                label="GST Number"
                                required
                                value={gstNo}
                                onChange={(e) => setGstNo(e.target.value.trim())}
                                fullWidth
                                variant="outlined"
                                sx={MInput.b}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                  },
                                }}
                              />
                            </FormControl>
                          </Grid>
                        )}
                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <TextField
                              label="PAN Number"
                              required
                              value={panNumber}
                              onChange={(e) => setPanNumber(e.target.value.trim())}
                              fullWidth
                              variant="outlined"
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <TextField
                              label="Street"
                              value={selectedStreet}
                              onChange={(e) => setSelectedStreet(formatInputValue(e.target.value))}
                              fullWidth
                              variant="outlined"
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <TextField
                              label="City"
                              value={selectedCity}
                              onChange={(e) => setSelectedCity(formatInputValue(e.target.value))}
                              fullWidth
                              variant="outlined"
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <TextField
                              label="State"
                              value={selectedState}
                              onChange={(e) => setSelectedState(formatInputValue(e.target.value))}
                              fullWidth
                              variant="outlined"
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <TextField
                              label="Phone Number"
                              fullWidth
                              type="tel"
                              required
                              onChange={(e) => {
                                const phoneNumberPattern = /^[1-9]\d{9}$/; // Example for Indian numbers
                                const value = e.target.value;
                                setSelectedPhoneNumber(value);
                                setPhoneNumberError(!phoneNumberPattern.test(value));
                              }}
                              value={selectedPhoneNumber}
                              error={phoneNumberError} // Display error if phone number is invalid
                              helperText={
                                phoneNumberError ? "Please enter a valid phone number" : ""
                              }
                              inputProps={{
                                maxLength: 10, // Restrict to 10 digits for phone numbers
                                pattern: "[6-9]{1}[0-9]{9}",
                              }}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <TextField
                              type="email"
                              label="Email ID"
                              required
                              value={selectedEmailID}
                              onChange={(e) => setSelectedEmailID(formatInputValue(e.target.value))}
                              fullWidth
                              variant="outlined"
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <TextField
                              label="Contact Person Name"
                              required
                              fullWidth
                              type="text"
                              onChange={(e) =>
                                setSelectedContactPerson(formatInputValue(e.target.value))
                              }
                              value={selectedContactPerson}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid sx={dsaMasterStyles.girdClass} mt={3} mb={3}>
                        <StyledButton type="submit">Save</StyledButton>
                      </Grid>
                    </form>
                  </Grid>
                </TableContainer>
              </Grid>
            </Grid>
          </StyledTableContainer>
        )}
      </Box>
    </Box>
  );
}

DsaMaster.propTypes = {
  data: PropTypes.object.isRequired,
  node: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
  }).isRequired,
  api: PropTypes.shape({
    getDisplayedRowAtIndex: PropTypes.func.isRequired, // Validating that api.getDisplayedRowAtIndex is a required function
  }).isRequired, // api itself is required
  openBankDailog: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  dsaId: PropTypes.string.isRequired,
  fetchBankAccounts: PropTypes.func.isRequired,
};
